module.exports = __webpack_public_path__ + "static/fonts/OpenSans700italic.ac92bed2.ttf";